import lrUserSelect from './_src/lrUserSelectMarket.vue'
lrUserSelect.install = function(Vue) {
  Vue.component(lrUserSelect.name, lrUserSelect)
}
export default lrUserSelect